<template>
  <div class="container-fiuid" style="min-height: 100vh">
    <div style="flex: 1">
      <b-container fluid>
        <!-- logo -->
        <logo_display
          :target_url="'https://foreverliving.com/hkg/zh-hk/home'"
        />
        <!-- logo -->
      </b-container>

      <!-- heading -->
      <page_banner :page_title="page_title" />
      <!-- heading -->

      <!-- main -->
      <b-container class="mt-3">
        <!-- faq category -->
        <div class="mt-3 mb-3">
          <b-button
            v-for="(data, index) in faq_sources"
            :key="index"
            class="category_button mx-2 my-2 font-weight-bold text"
            :class="{ active: faq_tab == data.title }"
            @click="change_faq_tab(data.title)"
            >{{ data.title }}
          </b-button>
        </div>
        <hr />
        <!-- faq category -->

        <!-- faq contents -->
        <div v-for="(data, index) in faq_sources" :key="index">
          <!-- fqa content -->
          <div v-if="faq_tab == data.title">
            <div v-for="(content, index) in data.faq_contents" :key="index">
              <faq_content :content="content" />
              <br />
            </div>
          </div>
          <!-- fqa content -->
        </div>
        <!-- faq contents -->
        <hr />
      </b-container>
      <!-- main -->
    </div>
    <div class="mt-5">
      <span v-if="current_language == '中文'">
        <footer_page />
      </span>
      <span v-if="current_language == 'English'">
        <footer_page_eng />
      </span>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";
import logo_display from "./logo_display.vue";
import page_banner from "./page_banner.vue";
import footer_page from "./footer_page.vue";
import footer_page_eng from "./footer_page_eng.vue";
import faq_content from "./faq_content.vue";
import api from "@/api";

const page_title = ref("");
const faq_tab = ref("");
const faq_sources = ref([]);
const language_version_valid_tabs = ref([]);
const current_language = ref("");

// used to switch the faq tab to display different contents
const change_faq_tab = (tab_name) => (faq_tab.value = tab_name);

// get the language tab by url
const load_language_version_from_url = () => {
  let hash = window.location.hash.slice(1);
  if (language_version_valid_tabs.value.includes(hash)) {
    current_language.value = hash;
  } else {
    current_language.value = "中文";
    window.location.hash = "#中文";
  }
};

/*
Retrieve all language versions via API,
and get the FAQ sources based on the language version.
*/
const get_resource = async () => {
  let language_version_response = await api.get("/api/get_language_version");
  language_version_response.data.forEach((data) => {
    language_version_valid_tabs.value.push(data.language_name);
  });
  load_language_version_from_url();
  let faq_response = await api.get("/api/get_faq", {
    params: { language: current_language.value },
  });
  faq_tab.value = faq_response.data[0].title;
  faq_sources.value = faq_response.data;
  console.log(faq_response.data);

  if (current_language.value == "中文") {
    page_title.value = "常見問題";
  } else if (current_language.value == "English") {
    page_title.value = "Frequently Asked Questions (FAQs)";
  }
};

onMounted(() => {
  get_resource();
  window.addEventListener("hashchange", get_resource);
});
onBeforeUnmount(() => {
  window.removeEventListener("hashchange", get_resource);
});
</script>

<style scoped>
.category_button {
  background-color: #ffc600;
  color: black;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  width: auto;
  display: inline-block;
}
.category_button:hover {
  background-color: #ffe4a3;
  color: #ffffff;
}
.category_button.active {
  background-color: #ffc600 !important;
  color: #ffffff !important;
  box-shadow: none !important;
  outline: none !important;
}
.category_button:focus {
  background-color: #ffc600 !important;
  color: #ffffff !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>
